import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux"
import AmenitiesService from 'services/Admin/AmenitiesService';

const CardItem = ({ index, item, id, name, status, toggleModal, setEditObj, setAdd, pageNum, searchId, setShouldGetData }) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [itemStatus, setItemStatus] = useState(false);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const service = new AmenitiesService()
    const toggle = () => setDropdownOpen(prevState => !prevState);

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    const handleCloseModal = (action, response) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };
    const changeStatus = (e) => {
        const value = e.target.checked
        service.update(id, {
            status: !status,
            name,
        }).then((res) => {
            if (res && res.status === SuccessOk) {
                setItemStatus(value)
                toast.success(res.data.success);
            }
        });
    }

    return (
        <>
            <tr key={index}>
                <td className='font-size-16'>{searchId || (((pageNum-1)*10)+(index+1))}</td>
                <td className='font-size-16'>{name.en}</td>

                <td className='font-size-14 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                disabled={isExist("setting.edit") ? false : true}
                                onChange={changeStatus}
                            />
                        </div>
                    </form>
                </td>
                {isExist("setting.edit") || isExist("setting.delete") ?
                    <td className="removebtnhover"><Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            {isExist("setting.edit") ? <DropdownItem onClick={() => {
                                setAdd(false)
                                setEditObj(item)
                                toggleModal()
                            }}>Edit</DropdownItem> : null}
                            {isExist("setting.delete") ? <DropdownItem className="text-danger" onClick={() => {
                                setDeleteModal(!deleteModal);
                            }}>Remove Amenities</DropdownItem> : null}
                        </DropdownMenu>
                    </Dropdown>
                    </td> : null}
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </>

    );
}

export default CardItem;